import { MessageMedium } from 'modules/graphql/types';
import { pxToRem } from 'utils/convert';

const customSpacing = {
  p40: pxToRem(40),
  p54: pxToRem(54),
};

// add to first row for checkbox: ${customSpacing.p54}
export const TABLE_GRID = `
  minmax(${customSpacing.p40}, 3.867fr) // Name 
  minmax(${customSpacing.p40}, .8fr) // Testing subject
  minmax(${customSpacing.p40}, 1fr) // Winning criteria
  minmax(${customSpacing.p40}, .8fr) // Status
  minmax(${customSpacing.p40}, 1fr) // Start date
  minmax(${customSpacing.p40}, 1fr) // End date
  minmax(${customSpacing.p40}, 1.9fr) // Last modified
  minmax(${customSpacing.p40}, 0.25fr) // Action menu
`;

export const CHOOSE_CAMPAIGN_TABLE_GRID = `
  ${pxToRem(92)}  // ID
  minmax(${pxToRem(194)}, 290fr) // Campaign name
  minmax(${pxToRem(100)}, 102fr) // Status
  minmax(${pxToRem(104)}, 169fr) // Campaign type
  minmax(${pxToRem(104)}, 106fr) // Medium
  minmax(auto, 212fr) // Experiment name
  minmax(${pxToRem(228)}, 200fr) // Last Modified
  ${pxToRem(178)} // Action menu
`;

export const DEFAULT_ROW_COUNT = 10;

export const MEDIUM_ICON_HEIGHT = 16;
export const MEDIUM_ICON_WIDTH = 16;

export const SEND_TIME_MEDIUMS = [MessageMedium.Email, MessageMedium.Push, MessageMedium.SMS];
export const STO_MEDIUMS = [MessageMedium.Email, MessageMedium.Push];
